import { useContext, useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Tooltip from '@mui/material/Tooltip';
import { APIContext } from '../Contexts/APIContext';

type MailchimpRequest = {
    id: string;
    userName: string;
    email: string;
    actioned: boolean;
    actionedByEmail?: string | null;
};

export default function MailchimpRequestsPage() {
    const { get, showMessage } = useContext(APIContext);
    const [hideActioned, setHideActioned] = useState(true);
    const [requests, setRequests] = useState<MailchimpRequest[]>([]);

    useEffect(() => {
        get('PromptAdmin', `GetMailchimpRequests?hideActioned=${hideActioned}`, setRequests);
    }, [hideActioned]);

    const toggleActioned = (request: MailchimpRequest, checked: boolean) => {
        get('PromptAdmin', `SetMailchimpRequestActioned?id=${request.id}&actioned=${checked}`, () => {
            showMessage('success', 'Mailchimp request updated');
            get('PromptAdmin', `GetMailchimpRequests?hideActioned=${hideActioned}`, setRequests);
        });
    };

    const copyEmail = async (email: string) => {
        await navigator.clipboard.writeText(email);
        showMessage('success', 'Email copied');
    };

    return (
        <Paper sx={{ p: 2 }}>
            <Grid container spacing={2}>
                <Grid size={12}>
                    <Typography variant="h4">Mailchimp Requests</Typography>
                </Grid>
                <Grid size={12}>
                    <FormControlLabel
                        control={<Checkbox checked={hideActioned} onChange={(event) => setHideActioned(event.target.checked)} />}
                        label="Hide actioned"
                    />
                </Grid>
                <Grid size={12}>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>User</TableCell>
                                    <TableCell>Email</TableCell>
                                    {!hideActioned && <TableCell>Actioned By</TableCell>}
                                    <TableCell>Actioned</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {requests.map((request) => (
                                    <TableRow key={request.id}>
                                        <TableCell>{request.userName}</TableCell>
                                        <TableCell>
                                            <Tooltip title="Copy email">
                                                <Typography
                                                    component="span"
                                                    onClick={() => copyEmail(request.email)}
                                                    sx={{
                                                        cursor: 'pointer',
                                                        userSelect: 'none'
                                                    }}
                                                >
                                                    {request.email}
                                                </Typography>
                                            </Tooltip>
                                        </TableCell>
                                        {!hideActioned && <TableCell>{request.actionedByEmail ?? ''}</TableCell>}
                                        <TableCell>
                                            <Checkbox
                                                checked={request.actioned}
                                                onChange={(event) => toggleActioned(request, event.target.checked)}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </Paper>
    );
}
